<template>
    <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
        <div class="row justify-content-center">
            <div class="col-xl-10">
                <h2 class="fs-xxl fw-500 mt-4 text-white text-center mb-2">
                    {{ __t(main_title) }}
                </h2>

                <p class="h5 fw-300 mb-5 text-white opacity-60 text-center">
                    {{ __t(main_description) }}
                </p>

                <div class="row justify-content-center">
                    <div class="col-xl-7 col-lg-8 col-md-10">
                        <div class="card register-card shadow-lg border-0 rounded-plus">
                            <div class="card-body p-4 p-lg-5">
                                <div class="form-group mb-4">
                                    <label class="form-label fw-500" for="email">
                                        {{ __t('EMAIL') }}
                                    </label>

                                    <input
                                        id="email"
                                        v-model.trim="user_form.email"
                                        type="email"
                                        class="form-control form-control-lg"
                                        :class="{ 'is-invalid': errors.email }"
                                        placeholder="example@email.com"
                                        autocomplete="email"
                                    >

                                    <div v-if="errors.email" class="invalid-feedback d-block">
                                        {{ errors.email }}
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <label class="form-label fw-500">
                                        {{ __t('PHONE') }}
                                    </label>

                                    <vue-tel-input
                                        v-model="user_form.phone"
                                        mode="international"
                                        :dropdown-options="{ showDialCodeInList: true, showFlags: true }"
                                        :input-options="telInputOptions"
                                        :valid-characters-only="true"
                                        :auto-default-country="true"
                                        :preferred-countries="['ua', 'pl', 'de', 'gb', 'us', 'ka', 'ge']"
                                        @input="onPhoneInput"
                                        class="tel-input-custom"
                                    />

                                    <div v-if="errors.phone" class="invalid-feedback d-block">
                                        {{ errors.phone }}
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <label class="form-label fw-500" for="name">
                                        {{ __t('NAME') }}
                                    </label>

                                    <input
                                        id="name"
                                        v-model.trim="user_form.name"
                                        type="text"
                                        class="form-control form-control-lg"
                                        :class="{ 'is-invalid': errors.name }"
                                        :placeholder="__t('U.NAME')"
                                        autocomplete="name"
                                    >

                                    <div v-if="errors.name" class="invalid-feedback d-block">
                                        {{ errors.name }}
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <label class="form-label fw-500" for="restaurant">
                                        {{ __t('BRAND_NAME') }}
                                    </label>

                                    <input
                                        id="restaurant"
                                        v-model.trim="user_form.brand"
                                        type="text"
                                        class="form-control form-control-lg"
                                        :class="{ 'is-invalid': errors.brand }"
                                        :placeholder="__t('BRAND_NAME')"
                                    >

                                    <div v-if="errors.brand" class="invalid-feedback d-block">
                                        {{ errors.brand }}
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <label class="form-label fw-500" for="password">
                                        {{ __t('PASSWORD') }}
                                    </label>

                                    <input
                                        id="password"
                                        v-model.trim="user_form.password"
                                        type="password"
                                        class="form-control form-control-lg"
                                        :class="{ 'is-invalid': errors.password }"
                                        :placeholder="__t('PASSWORD')"
                                        autocomplete="new-password"
                                    >

                                    <div v-if="errors.password" class="invalid-feedback d-block">
                                        {{ errors.password }}
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <label class="form-label fw-500 d-block">
                                        {{ __t('NUMBER_LOCATIONS') }}
                                    </label>

                                    <div class="pill-group">
                                        <label
                                            v-for="item in locationOptions"
                                            :key="item.value"
                                            class="pill-option"
                                            :class="{ active: user_form.locations === item.value }"
                                        >
                                            <input
                                                v-model="user_form.locations"
                                                type="radio"
                                                :value="item.value"
                                                class="pill-input"
                                            >
                                            <span>{{ item.label }}</span>
                                        </label>
                                    </div>

                                    <div v-if="errors.locations" class="invalid-feedback d-block">
                                        {{ errors.locations }}
                                    </div>
                                </div>

                                <div class="d-flex justify-content-end pt-2">
                                    <button
                                        @click="make_register"
                                        :disabled="is_loading || !form_valid"
                                        class="btn btn-outline-primary btn-lg px-5 waves-effect waves-themed"
                                    >
                                        <span v-if="!is_loading">{{ __t('NEXT') }}</span>
                                        <span v-else>{{ __t('LOADING') }}...</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
    name: "general_register",

    components: {
        VueTelInput
    },

    data() {
        return {
            is_loading: false,
            errors: {},
            countries: {},

            locationOptions: [
                { label: '1-2', value: '1-2' },
                { label: '3-5', value: '3-5' },
                { label: '6-49', value: '6-49' },
                { label: '50-500', value: '50-500' },
                { label: '500+', value: '500+' }
            ],

            phoneMeta: {
                isValid: false,
                country: null,
                formatted: ''
            },

            user_form: {
                email: "",
                phone: "",
                name: "",
                brand: "",
                locations: "1-2",
                password: "",
            },

            telInputOptions: {
                placeholder: 'Enter phone number',
                name: 'phone',
                autocomplete: 'tel',
                class: 'form-control form-control-lg'
            }
        }
    },

    created() {
        this.load_countries();
    },

    computed: {
        form_valid() {
            return Object.keys(this.validateForm()).length === 0;
        },

        main_title() {
            return 'REGISTER_TITLE';
        },

        main_description() {
            return 'REGISTER_DESCRIPTION';
        }
    },

    methods: {
        async load_countries() {
            try {
                const { data } = await api.get('/api/v2/countries');

                if (data.status === "operation_success") {
                    this.countries = data.data || {};
                }
            } catch ({ response }) {
                _core.hideloading();
                EventBus.$emit('show_toast', {
                    err: response?.data?.message || 'Load countries error',
                    type: "danger",
                    title: response?.data?.status || 'error'
                });
            }
        },

        onPhoneInput(phone, meta) {
            this.user_form.phone = phone;
            this.phoneMeta = {
                isValid: meta?.valid || false,
                country: meta?.country || null,
                formatted: meta?.formatted || phone
            };
        },

        validateForm() {
            const errors = {};

            const email = this.user_form.email?.trim();
            const name = this.user_form.name?.trim();
            const brand = this.user_form.brand?.trim();
            const phone = this.user_form.phone?.trim();
            const password = this.user_form.password?.trim();
            const locations = this.user_form.locations?.trim();

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!email) {
                errors.email = this.__t('FIELD_REQUIRED');
            } else if (!emailRegex.test(email)) {
                errors.email = this.__t('INVALID_EMAIL');
            }

            if (!phone) {
                errors.phone = this.__t('FIELD_REQUIRED');
            } else if (!this.phoneMeta.isValid) {
                errors.phone = this.__t('INVALID_PHONE');
            }

            if (!name) {
                errors.name = this.__t('FIELD_REQUIRED');
            }

            if (!brand) {
                errors.brand = this.__t('FIELD_REQUIRED');
            }

            if (!password) {
                errors.password = this.__t('FIELD_REQUIRED');
            } else if (password.length < 6) {
                errors.password = this.__t('PASSWORD_MIN_6') || 'Minimum 6 characters';
            }

            if (!locations) {
                errors.locations = this.__t('FIELD_REQUIRED');
            }
            console.log(errors);

            return errors;
        },

        async make_register() {
            this.errors = this.validateForm();

            if (Object.keys(this.errors).length) {
                return;
            }

            this.is_loading = true;
            _core.showloading();

            try {
                const send_data = {
                    ...this.user_form,
                    phone: this.phoneMeta.formatted || this.user_form.phone
                };
                const params = new URLSearchParams(window.location.search);
                send_data.utm_tag = params.get('utm_tag') || '';

                const { data } = await api.post('/registration', send_data);

                _core.hideloading();
                this.is_loading = false;

                if (data.status === "operation_success") {
                    EventBus.$emit('show_toast', {
                        err: this.__t('SUCCESS'),
                        type: "success",
                        title: this.__t('DONE')
                    });

                    window.location.href = data.data?.url;

                } else {
                    EventBus.$emit('show_toast', {
                        err: this.__t('ERR'),
                        type: "danger",
                        title: "Нет"
                    });
                }
            } catch ({ response }) {
                _core.hideloading();
                this.is_loading = false;

                EventBus.$emit('show_toast', {
                    err: response?.data?.message || 'Register error',
                    type: "danger",
                    title: response?.data?.status || 'error'
                });
            }
        }
    }
}
</script>

<style scoped>
.register-card {
    backdrop-filter: blur(8px);
    border-radius: 24px;
    background: #ffffff;
}

.form-label {
    margin-bottom: 10px;
    color: #2c2c2c;
    font-size: 15px;
    font-weight: 500;
}

.form-control,
::v-deep .vue-tel-input {
    min-height: 54px;
    border-radius: 16px;
}

.form-control {
    border: 1px solid #d9d9d9;
    box-shadow: none;
    font-size: 15px;
    padding-left: 16px;
    padding-right: 16px;
}

.form-control:focus {
    border-color: #18b368;
    box-shadow: 0 0 0 0.15rem rgba(24, 179, 104, 0.12);
}

::v-deep .vue-tel-input {
    display: flex;
    align-items: center;
    border: 1px solid #d9d9d9;
    background: #fff;
    border-radius: 16px;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    min-height: 54px;
}

::v-deep .vue-tel-input:focus-within {
    border-color: #18b368;
    box-shadow: 0 0 0 0.15rem rgba(24, 179, 104, 0.12);
}

::v-deep .vti__input {
    border: 0 !important;
    box-shadow: none !important;
    font-size: 15px;
    min-height: 52px;
    border-radius: 16px;
    padding-left: 8px;
}

::v-deep .vti__dropdown {
    border: 0 !important;
    background: transparent !important;
    border-radius: 16px 0 0 16px;
    padding-left: 10px;
}

.pill-group {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 4px;
}

.pill-option {
    position: relative;
    min-width: 108px;
    height: 38px;
    padding: 0 20px;
    border: 1.5px solid #b7b7b7;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #fff;
    transition: all .2s ease;
    font-size: 14px;
    color: #444;
    line-height: 1;
    user-select: none;
}

.pill-option:hover {
    border-color: #8f8f8f;
}

.pill-option.active {
    border-color: #18b368;
    background: rgba(24, 179, 104, 0.06);
    color: #18b368;
    font-weight: 600;
}

.pill-input {
    display: none;
}

.invalid-feedback {
    font-size: 13px;
    margin-top: 6px;
}

.btn[disabled] {
    opacity: 0.65;
    cursor: not-allowed;
}

@media (max-width: 576px) {
    .pill-group {
        gap: 8px;
    }

    .pill-option {
        min-width: calc(50% - 4px);
    }
}
</style>
